import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_HOUSEHOLD_GET_RENTER_LISTING_QUALIFICATION } from 'api/actionTypes';

export default async function getRenterListingQualification(
  { state, apiClient },
  { userId, listingId },
) {
  typeCheck('userId::PositiveNumber', userId);
  typeCheck('listingId::PositiveNumber', listingId);
  return apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_GET_RENTER_LISTING_QUALIFICATION,
    queryId: `${userId}-${listingId}`,
    state: state,
    payload: {
      userId,
      listingId,
    },
    onSuccess(result) {
      state.set(['household', 'renterQualificationsByListingId', String(listingId)], result);
    },
  });
}
